export default __webpack_public_path__ + "static/media/Blade's Tunic of Arcane Death.571d5f8c.jpg";